import { ProgressBar } from "primereact/progressbar"
import styles from "../../styles/Loader.module.css"

export function LoaderSmall({ style }) {
  return (
    <RLinkLoader style={style}></RLinkLoader>
  )
}

export function LoaderProgressBar() {
  return (
    <div>
      <ProgressBar mode="indeterminate" style={{ height: "3px" }}></ProgressBar>
    </div>
  )
}

export function LoaderMedium({ style }) {
  return (
    <RLinkLoader style={style} />
  )
}

export default function LoaderFullPage({ style }) {
  return (
    <RLinkLoader style={style} />
  )
}

export function RLinkLoader({ style }) {
  return (
    <div
      className={styles.loader_container}
      style={{ margin: "auto", marginTop: "8%", ...style }}
    >
      <div className={styles.pulse_loader}>
        <div className={styles.pulse}></div>
        <div className={styles.pulse}></div>
        <div className={styles.pulse}></div>
      </div>
    </div>
  )
}
